import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authService } from "../services/auth.service";
import { identify, resetAnalytics, track, EVT } from "../lib/analytics";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = unauth, object = user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const data = await authService.me();
      setUser(data);
      identify(data);
      return data;
    } catch (e) {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await authService.logout(); } catch {}
    track(EVT.user_logged_out);
    resetAnalytics();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
